import React from "react";
import { connect } from "react-redux";
import { withFormik } from "formik";
import { compose } from "redux";
import { withTheme } from "@material-ui/core/styles";
import {
  Grid,
  TextField,
  FormControl,
  Button,
  DialogContent
} from "@material-ui/core";
import { fetchSingleFund, updateFund } from "store/state/fund";
import { showAssignModal } from "store/state/modals/assignFund";
import Modal from "components/Modal";
import ModalActions from "components/Modal/Actions";
import ConfirmCloseDialog from "./ConfirmCloseDialog";
import Styles from "./styles";
import Avps from "./Avps";
import CustomAvps from "./CustomAvps";

class FundEditModal extends React.Component {
  state = {
    confirmDialogOpen: false
  };

  handleCloseConfirmationDialogAndRedirect = () => {
    const { history, fund } = this.props;
    this.setState({ confirmDialogOpen: false });
    history.push(`/funds/${fund.id}`);
  };

  saveAndClose = e => {
    const { handleSubmit, history, fund, onUpdate } = this.props;
    handleSubmit(e);
    setTimeout(() => {
      history.push(`/funds/${fund.id}`);
      onUpdate();
    });
  };

  save = e => {
    const { handleSubmit, onUpdate } = this.props;
    handleSubmit(e);
    setTimeout(() => {
      onUpdate();
    })
  };

  handleCloseConfirmationDialog = () => {
    this.setState({ confirmDialogOpen: false });
  };

  openDialog = () => {
    const { dirty, history, fund } = this.props;
    if (!dirty) {
      this.props.fetchSingleFund(fund.id);
      return history.push(`/funds/${fund.id}`);
    }
    return this.setState({ confirmDialogOpen: true });
  };

  getFeatureImage = file => {
    this.setState(file);
  };

  render() {
    const {
      fund,
      handleChange,
      values,
      errors,
      touched,
      theme,
      setFieldValue
    } = this.props;        
    const {name, avps} = values;    
    const formik = {
      handleChange,
      values,
      errors,
      touched,
      setFieldValue
    };

    const title = fund ? `Editing: ${name}` : "Editing";

    return (
      <div>
        {fund && (
          <Modal modalTitle={title} open hideModal={this.openDialog}>
            <Styles theme={theme}>
              <DialogContent classes={{ root: "DialogContent" }}>
                <div className="form-section">
                  <Grid container classes={{ container: "FormGroup" }}>
                    <Grid item xs={12} className="row">
                      <FormControl className="avps_FieldsTextarea selectField">
                        <TextField
                          label="Name"
                          className="avps_FieldsTextarea"
                          type="text"
                          margin="normal"
                          name="name"
                          defaultValue={name || ""}
                          onChange={handleChange}
                        />
                        {Object.keys(avps["Fund Information"].Details).map(
                          avp => (
                            <Avps
                              key={avp}
                              avps={avps["Fund Information"].Details[avp]}
                              avpName={avp}
                              formik={formik}
                              fund={values}
                            />
                          )
                        )}
                        <CustomAvps fund={values} formik={formik} />
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
              </DialogContent>
              <ModalActions>
                <Button type="submit" onClick={this.save}>
                  Save
                </Button>
                <Button onClick={this.saveAndClose}>Save &amp; Close</Button>
                <Button onClick={this.openDialog}>Cancel</Button>
              </ModalActions>
            </Styles>
            <ConfirmCloseDialog
              open={this.state.confirmDialogOpen}
              handleCloseConfirmationDialog={this.handleCloseConfirmationDialog}
              handleCloseConfirmationDialogAndRedirect={
                this.handleCloseConfirmationDialogAndRedirect
              }
            />
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { authentication, loading } = state;
  return {
    authentication,
    loading    
  };
};

export default compose(
  connect(
    mapStateToProps,
    { updateFund, fetchSingleFund, showAssignModal }
  ),
  withFormik({
    mapPropsToValues: props => props.fund,
    enableReinitialize: true,
    handleSubmit: (values, { props, setSubmitting }) => {
      props.updateFund(values);
      setSubmitting(false);
    },
    displayName: "FundEditModal"
  }),
  withTheme()
)(FundEditModal);
